import * as i from 'types';
import * as React from 'react';

import { RangeSlider } from 'common/form';
import { useQuestionnaireContext } from 'modules/questionnaire';
import { transformQuestionId } from 'services';

import {
  DepreciationAnswer,
  DepreciationAnswerContainer,
  DepreciationSubtitle,
  DepreciationTitle,
} from './styled';

export const DepreciationSlider: React.FC<RadioFormProps> = ({
  questionId,
}) => {
  const { answers, updateAnswer } = useQuestionnaireContext();
  const answer = answers?.[transformQuestionId(questionId)] as string;

  React.useEffect(() => {
    if (answers) {
      updateAnswer({
        ...answers,
        [questionId]: answer || '5',
      });
    }
  }, []);

  const onChange = (value: string) => {
    updateAnswer({
      ...answers,
      [questionId]: value,
    });
  };

  const calculateMargin = () => {
    const multiplier = parseInt(answer) - 1;
    const total = (100 / 9) * multiplier;
    let correction = 1.5;

    if (total > 90) correction = 5;
    else if (total > 75) correction = 4.5;
    else if (total > 55) correction = 4;
    else if (total > 45) correction = 3.5;
    else if (total > 35) correction = 3;
    else if (total > 25) correction = 2.5;
    else if (total > 10) correction = 2;

    return total - correction;
  };

  return (
    <>
      <RangeSlider
        min="1"
        max="10"
        step="1"
        steps={10}
        {...{ answer, onChange }}
        isDeprecationSlider
      />
      <DepreciationAnswerContainer>
        <DepreciationAnswer marginLeft={calculateMargin()}>
          <DepreciationTitle>{answer}</DepreciationTitle>
          <DepreciationSubtitle>jaar</DepreciationSubtitle>
        </DepreciationAnswer>
      </DepreciationAnswerContainer>
    </>
  );
};

type RadioFormProps = {
  questionId: i.QuestionIds;
};
